import React from 'react';
import { Grid, Typography, Skeleton, Tooltip } from '@mui/material';
import { IComponentCss, Widget } from '@tap/mui-ui';
import { HomeFilter, HomeFilterValue } from './HomeFilter';
import { DataCollection, DocUpdateIssueStatReportRow } from '@tap/data-providers';
import { dateTimeHelper } from '@tap/utils';

/*
*   Виджет: статистика
*/

export type ICalculationResult = {
    percentagePlanOnTime: number,
    workingHours: number,
    workStartDate: number,
    workEndDate: number,
    equipmentLoading: number,
    adjustmentCountSum: number,
}

const skeletonHeight: number = 126;

const css: IComponentCss = {
    widget: {
        height: '100%',
        minHeight: '210px',
    },
    dateTimeUpdate: {
        position: 'absolute',
        color: '#999999',
        top: '22px',
        right: '22px',
        fontSize: '14px',
    },
    dots: {
        borderBottom: '1px dotted #212121',
        flex: 1,
        marginBottom: '4px',
    },
};

const calcStaticWidgetData = (statReportData: DataCollection<DocUpdateIssueStatReportRow[]> | undefined, filterValue: HomeFilterValue) => {

    if (!statReportData?.data?.length) return [];

    const reportData = statReportData?.data
        ?.filter(item => {
            return (filterValue?.departmentIds?.length === 0 || filterValue?.departmentIds?.includes(item.department?.id))
                && (filterValue?.isueType?.length === 0 || filterValue?.isueType?.includes(`${item.issueType}-${item.documentCode}`))
                && (filterValue?.manufactories?.length === 0 || filterValue?.manufactories?.includes(item.department?.manufactory))
        })
        ?.reduce((acc, currVal) => {
            return {
                newIssueCount: acc.newIssueCount + currVal.newIssueCount,
                inWorkIssueCount: acc.inWorkIssueCount + currVal.inWorkIssueCount,
                completedTodayCount: acc.completedTodayCount + currVal.completedTodayCount,
            }
        }, { newIssueCount: 0, inWorkIssueCount: 0, completedTodayCount: 0 });

    return [
        {
            label: 'Всего новых заявок',
            value: reportData.newIssueCount,
        },
        {
            label: 'Заявки в работе',
            value: reportData.inWorkIssueCount,
        },
        {
            label: 'Завершено сегодня заявок',
            value: reportData.completedTodayCount,
        },
    ]
}

export type StatisticsWidgetProps = {
    statReportData?: DataCollection<DocUpdateIssueStatReportRow[]>,
    statReportLoading: boolean,
}

export default function StatisticsWidget({ statReportData, statReportLoading }: StatisticsWidgetProps) {
    const { filterValue } = HomeFilter.useContext();

    const statistics = calcStaticWidgetData(statReportData, filterValue);

    return (
        <Widget
            title={'Статистика'}
            widgetSx={css.widget}
        >

            {Boolean(statReportData?.changedAtUtc) && (
                <Grid sx={css.dateTimeUpdate}>
                    <Tooltip
                        title={`Дата обновления: ${dateTimeHelper.format(statReportData?.changedAtUtc, 'dd.MM.yyyy  HH:mm')}`}
                    >
                        <span>
                            обновлено {dateTimeHelper.format(statReportData?.changedAtUtc, 'HH:mm')}
                        </span>
                    </Tooltip>
                </Grid>
            )}


            <Grid>
                {/* Результаты расчетов */}
                {!statReportLoading && statistics && statistics.length > 0 &&
                    statistics.map((item: any) =>
                        <Grid
                            key={item.label}
                            container
                            justifyContent='space-between'
                            alignItems='stretch'
                        >
                            <Typography variant='body1'>{item.label}</Typography>
                            <Grid sx={css.dots}> </Grid>
                            <Typography variant='body1'>{item.value}</Typography>
                        </Grid>,
                    )
                }

                {/* Скелетон при загрузке */}
                {statReportLoading &&
                    <Skeleton variant='rectangular' height={skeletonHeight} />
                }

                {/* Если нет данных для отображения */}
                {!  !statReportLoading && statistics && statistics.length === 0 &&
                    <Typography color='gray'>Нет данных для отображения</Typography>
                }
            </Grid>
        </Widget>
    );
}

